import { render, staticRenderFns } from "./ParcelLocationOfGoodsSection.vue?vue&type=template&id=7dd39ea3&scoped=true&"
import script from "./ParcelLocationOfGoodsSection.vue?vue&type=script&lang=js&"
export * from "./ParcelLocationOfGoodsSection.vue?vue&type=script&lang=js&"
import style0 from "./ParcelLocationOfGoodsSection.vue?vue&type=style&index=0&id=7dd39ea3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd39ea3",
  null
  
)

export default component.exports